<template>
  <div class='booking-details__documents-row'>
    <label class='booking-details__checkbox'>
      <input
        type='checkbox'
        :checked='selected_documents.includes(document.id)'
        @change='handleCheckboxChange'
      />
      <div class='booking-details__checkbox-indicator'></div>
      <span class='booking-details__checkbox-label line-clamp-1'>{{ document.name }}</span>
    </label>
    <div class='booking-details__documents-actions'>
        <a v-if="document.pdf == 1"
                  :data-rel="'lightcase:myCollection' + document.id + 'desktop'"
                  class='theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2'
                  :title='document.name'
                  :href='document.document_url'
                ><i class='icon-eye' style='font-size: 20px;'></i>
                <span class="hidden lg:block">{{ locales && locales.common && locales.common.view}}</span>
                <v-lightcase-holder
                  :current-document='document'
                  :disable-rotate='true'
                  :image-src='document.document_url'
                  :name="'box-' + document.id"
                />
              </a>
      <a v-else :href="'#box-' + document.id" :data-rel="'lightcase:myCollection' + document.id + 'desktop'" class='theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2'>
        <i class='icon-eye' style='font-size: 20px;'></i>
        <span class="hidden lg:block">{{ locales && locales.common && locales.common.view}}</span>
        <v-lightcase-holder
          :current-document='document'
          :disable-rotate='true'
          :image-src='document.document_url'
          :name="'box-' + document.id"
        />
      </a>
      <!-- <a :href="'#box-' + document.id" :data-rel="'lightcase:myCollection' + document.id + 'mobile'" class='theme-btn theme-btn--square--small theme-btn--tertiary lg:hidden'>
        <i class='icon-eye' style='font-size: 20px;'></i>
      </a> -->
      <a :class="['theme-btn theme-btn--square--small theme-btn--gray lg:hidden', actionsPopup && 'theme-btn--gray-active']" ref='toggleButton' @click.prevent='togglePopup'>
        <i class='icon-dots-horizontal' style='font-size: 20px;'></i>
      </a>
      <div ref='popup' :class="['booking-details__documents-actions-popup', actionsPopup && 'booking-details__documents-actions-popup--active']">
        <span class='theme-btn theme-btn--small theme-btn--destructive' @click='handleRemove'>{{ locales && locales.common && locales.common.remove}}</span>
        <label class='theme-btn theme-btn--small theme-btn--theme whitespace-nowrap'>
          {{ locales && locales.common && locales.common.upload_new}}
          <input
            :data-id="document.id"
            style='display: none;'
            accept="application/pdf, image/*"
            name="document[]"
            type='file'
            @change='handleFileChange'
            @file_updated="this.$emit('update:imageSrc', document.document_url)"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      document: {
        default: {},
        type: Object,
      },
      selected_documents: {
        default: [],
        type: Array,
      },
    },
    computed: {
      ...mapGetters(["locales"]),
    },
    data() {
      return {
        actionsPopup: false,
      };
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
      togglePopup() {
        this.actionsPopup = !this.actionsPopup;
        if (this.actionsPopup) {
          document.addEventListener('click', this.handleClickOutside);
        } else {
          document.removeEventListener('click', this.handleClickOutside);
        }
      },
      handleClickOutside(event) {
        if (!this.$refs.popup.contains(event.target) && !this.$refs.toggleButton.contains(event.target)) {
          this.actionsPopup = false;
          document.removeEventListener('click', this.handleClickOutside);
        }
      },
      handleCheckboxChange() {
        this.$emit('handle_checkbox_change');
      },
      handleRemove() {
        this.$emit('remove');
      },
      handleFileChange(event) {
        this.$emit('file_change', event);
      },
    },
  };
</script>